import { apiClient } from './client';

/**
 * Achievements 2.0 for staff (GAMIFICATION_SPEC §4.2). Names arrive in the
 * CRM's language via Accept-Language; `_` busts the GET cache after an award.
 */

/** One student's achievements, next up and engagement risk. */
export async function getStudentAchievements(userId, lang = 'uz', fresh = false) {
  const { data } = await apiClient.get(`/crm/students/${userId}/achievements`, {
    headers: { 'Accept-Language': lang },
    params: fresh ? { _: Date.now() } : undefined,
  });
  return data?.data ?? data;
}

/** Give "Ustoz tanlovi" with a note (shown to the student). */
export async function awardTeacherPick(userId, note, lang = 'uz') {
  const { data } = await apiClient.post(
    `/crm/students/${userId}/achievements`,
    { note },
    { headers: { 'Accept-Language': lang } },
  );
  return data?.data ?? data;
}

/** Students of a course (or of the organisation) with counts and risk band. */
export async function getAchievementsOverview(courseId, lang = 'uz') {
  const { data } = await apiClient.get('/crm/achievements/overview', {
    headers: { 'Accept-Language': lang },
    params: courseId ? { courseId } : undefined,
  });
  return data?.data ?? data;
}
